<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.13545 2.49951C5.9109 2.49951 3.98372 3.71204 2.98957 5.48908L5 7.49951H1.66956C1.56002 7.51843 1.44594 7.51922 1.33146 7.49951H0V2.49951L1.53482 4.03433C2.93892 1.90309 5.37456 0.499512 8.13545 0.499512C12.463 0.499512 16 3.95351 16 8.24951C16 12.5455 12.463 15.9995 8.13545 15.9995C5.23141 15.9995 2.68941 14.4469 1.32735 12.1316C1.04731 11.6555 1.20619 11.0426 1.68221 10.7626C2.15823 10.4826 2.77114 10.6414 3.05118 11.1175C4.06294 12.8373 5.9578 13.9995 8.13545 13.9995C11.3903 13.9995 14 11.4094 14 8.24951C14 5.08967 11.3903 2.49951 8.13545 2.49951Z"
  />
</template>
